import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext, TokenContext } from "../../auth";

const PrivateRoute = ({ component: Component, admin, ...rest }) => {
  const { currentUser } = useContext(AuthContext);
  const { userToken } = useContext(TokenContext);

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        currentUser && (admin ? userToken.claims.admin : true) ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRoute;
